module.exports = function hasUdfFields(name) {
  return ['Ohip', 'Opera', 'Cloudbeds', 'Cloudbeds_new'].includes(name);
};
